// reducers/test-maintenance/reset.js

export function resetHasErrored(state = false, action) {
  switch (action.type) {
    case 'RESET_TEST_M_HAS_ERRORED':
      return action.hasErrored;
    default:
      return state;
  }
}

export function resetIsLoading(state = false, action) {
  switch (action.type) {
    case 'RESET_TEST_M_IS_LOADING':
      return action.isLoading;
    default:
      return state;
  }
}

export function reset(state = {}, action) {
  switch (action.type) {
    case 'RESET_TEST_M_FETCH_DATA_SUCCESS':
      return action.resp;
    default:
      return state;
  }
}